import React from 'react';

interface IconProps extends React.SVGProps<SVGSVGElement> {
  className?: string;
}

/**
 * Unite / Union: Combines both overlapping shapes into a single solid merged contour
 */
export const PathfinderUnionIcon: React.FC<IconProps> = ({ className = 'w-4 h-4', ...props }) => (
  <svg viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} {...props}>
    <path
      d="M2 2h8v4h6v10H6v-4H2V2z"
      fill="currentColor"
    />
  </svg>
);

/**
 * Subtract / Minus Front: Subtracts the top overlapping front shape from the bottom back shape
 */
export const PathfinderSubtractIcon: React.FC<IconProps> = ({ className = 'w-4 h-4', ...props }) => (
  <svg viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} {...props}>
    <path
      d="M2 2h8v4H6v4H2V2z"
      fill="currentColor"
    />
    <rect
      x="6"
      y="6"
      width="10"
      height="10"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeDasharray="2 1.5"
      opacity="0.65"
    />
  </svg>
);

/**
 * Intersect: Keeps only the overlapping intersection area of both shapes
 */
export const PathfinderIntersectIcon: React.FC<IconProps> = ({ className = 'w-4 h-4', ...props }) => (
  <svg viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} {...props}>
    <rect
      x="2"
      y="2"
      width="8"
      height="8"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeDasharray="2 1.5"
      opacity="0.5"
    />
    <rect
      x="6"
      y="6"
      width="10"
      height="10"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeDasharray="2 1.5"
      opacity="0.5"
    />
    <rect
      x="6"
      y="6"
      width="4"
      height="4"
      fill="currentColor"
    />
  </svg>
);

/**
 * Exclude / XOR: Keeps non-overlapping areas, cutting out the intersection
 */
export const PathfinderExcludeIcon: React.FC<IconProps> = ({ className = 'w-4 h-4', ...props }) => (
  <svg viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2 2h8v8H2V2zm4 4h10v10H6V6z"
      fill="currentColor"
    />
  </svg>
);
